import React from 'react';
import { useNavigate } from 'react-router-dom';

const AdminHeader = ({ title, children }) => {
    const navigate = useNavigate();

    return (
        <header className="admin-header">
            <div className="admin-header-content">
                <h1>{title}</h1>
                <div className="admin-header-actions">
                    {children}
                    <span className="admin-user">
                        Welcome, {localStorage.getItem('adminUser')}
                    </span>
                    <button onClick={() => navigate('/admin')} className="logout-button">
                        Logout
                    </button>
                </div>
            </div>
        </header>
    );
};

export default AdminHeader;
